import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { Form, FormGroup, Row, Col } from "react-bootstrap";

import Button from "../../../../components/common/button/Button";
import Input from "../../../../components/common/input/Input";
import RichEditor from "../../../../components/common/richEditor/RichEditor";
import Select2 from "../../../../components/common/select/Select2";
import Steps from "../../../../components/common/steps/Steps";
import Typeahead from "../../../../components/common/typeahead/Typeahead";

import { required, maxLength } from "../../../../utils/forms/validators";
import ScrollToTopOnMount from "../../../../utils/scroll/ScrollToTopOnMount";

import {
  getProject,
  PROJECT_DETAIL_FORM
} from "../../../../actions/project.actions";

import styles from "./ProjectDetail.scss";

const maxLengthValidation = (max, msg) => maxLength(max, msg);

const richEditorValidation = (max, msg) => value => {
  const valueParse = value
    ? value.replace(/<[^>]*>/g, "").replace("&nbsp;", " ")
    : "";
  return valueParse.length > max && msg;
};

const title = maxLengthValidation(
  40,
  "Title must be less than or equal to 40 characters."
);

const overview = maxLengthValidation(
  1001,
  "Overview must be less than or equal to 1000 characters."
);

const responsibilities = richEditorValidation(
  2501,
  "Responsabilities must be less than or equal to 2500 characters."
);

class ProjectDetail extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { submitting, valid, cities, onSearchCities, isLoading } = this.props;

    const selectedCityProps = {};
    if (this.props.defaultLocation) {
      selectedCityProps.selected = [this.props.defaultLocation];
    }

    return (
      <section>
        <ScrollToTopOnMount />
        <section className={styles.projectDetail}>
          <div className={styles.header}>
            <Steps steps={this.props.steps} activeStep={1} track={true} />
          </div>
          <div className={styles.content}>
            <h2 className={styles.title}>Project Detail</h2>

            <Form onSubmit={this.props.handleSubmit}>
              <div className={styles.form}>
                <FormGroup>
                  <div className={styles.subtitle}>
                    Please outline the responsibilities of the role you’re
                    trying to fill and the specific details of the project. The
                    information you provide here will help find the ideal
                    candidate.
                  </div>
                </FormGroup>
                <FormGroup>
                  <div className={styles.dividerDouble} />

                  <div className={styles.sectionTitle}>Title</div>
                  <div className={styles.sectionDescription}>
                    E.g. VP of Marketing, Chief Financial Officer, Creative
                    Director
                  </div>

                  <Row>
                    <Col md={6} xs={12}>
                      <Field
                        name="title"
                        type="text"
                        placeholder="Project Title"
                        component={Input}
                        validate={[required, title]}
                        //help='40 characters max'
                      />
                    </Col>
                  </Row>

                  <div className={styles.divider} />

                  <div className={styles.sectionTitle}>Overview</div>
                  <div className={styles.sectionDescription}>
                    First impressions are everything. Members will see dozens of
                    Projects in their inbox, so make this exciting enough that
                    they’ll send you a great pitch.
                  </div>

                  <Field
                    name="overview"
                    component={RichEditor}
                    placeholder="Use this space to give a brief overview of the project and what you want to accomplish.
                     You'll be able to provide more specific details below."
                    //help='500 characters max'
                    maxLength={1001}
                    validate={overview}
                  />

                  <div className={styles.divider} />

                  <div className={styles.sectionTitle}>
                    Responsibilities + Deliverables
                  </div>
                  <div className={styles.sectionDescription}>
                    Here's where to get specific on the exact tasks you'll want
                    the member to perform. The more specific you are, the better
                    your pitches will be.
                  </div>

                  <Field
                    name="responsibilities"
                    component={RichEditor}
                    placeHolder="Use this space to outline your timeline, specific deliverables and expectations
                     for the member."
                    //help='1,100 characters max'
                    maxLength={2501}
                    validate={responsibilities}
                  />

                  <div className={styles.divider} />

                  <div className={styles.sectionTitle}>Location</div>

                  <Row>
                    <Col md={6} xs={12}>
                      <Field
                        name="city"
                        type="text"
                        placeholder="Office Location (City, State)"
                        component={Typeahead}
                        onSearch={query => onSearchCities(query)}
                        isLoading={isLoading || false}
                        options={cities}
                        isAsync={true}
                        minLength={3}
                        allowNew={false}
                        labelKey="description"
                        valueKey="id"
                        icon="map-marker"
                        validate={required}
                        {...selectedCityProps}
                      />
                    </Col>
                    <Col md={6} xs={12}>
                      <Field
                        name="work_type_id"
                        type="select"
                        placeholder="Work From..."
                        component={Select2}
                        options={this.props.workTypes}
                        validate={required}
                      />
                    </Col>
                  </Row>
                </FormGroup>

                <div className={styles.dividerDouble} />

                <div className={styles.CTAContainer}>
                  <Button
                    isPrimary
                    type="submit"
                    size={"large"}
                    label="Save + Continue"
                    isDisabled={!valid || submitting}
                  />
                </div>
              </div>
            </Form>
          </div>
        </section>
      </section>
    );
  }
}

ProjectDetail = reduxForm({
  form: PROJECT_DETAIL_FORM,
  touchOnChange: true,
  touchOnBlur: true,
  enableReinitialize: true
})(ProjectDetail);

const selector = formValueSelector(PROJECT_DETAIL_FORM);
ProjectDetail = connect(
  state => {
    const defaultLocation = selector(state, "city");
    return {
      defaultLocation,
      initialValues: state.project.data.data
    };
  },
  dispatch => {
    return {
      getProject: () => dispatch(getProject())
    };
  }
)(ProjectDetail);

export default ProjectDetail;



// WEBPACK FOOTER //
// ./src/routes/employer/project/components/ProjectDetail.js